var _path, _tspan, _tspan2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMayo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 195 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6d2150",
    d: "m169 122-26-8-18-5V69H15V43H0V31h1a749 749 0 0 1 13-1v-8l1-7h146l2-4 1-3V0h5v9h26v49h-1a306 306 0 0 1-15 1 9031 9031 0 0 0-1 66l-9-3z"
  })), /*#__PURE__*/React.createElement("text", {
    x: 105,
    y: 36,
    fill: "#ffffff",
    fontFamily: "Arial",
    fontSize: 21,
    fontWeight: 300,
    style: {
      InkscapeFontSpecification: "'Arial Bold'",
      textAlign: "center"
    },
    textAnchor: "middle"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 105,
    y: 36
  }, "Mayo")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 105,
    y: 63
  }, "Building"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMayo);
export default __webpack_public_path__ + "static/media/Mayo.ca278328744c1fdde026fefe991ae24a.svg";
export { ForwardRef as ReactComponent };